<template>
    <div class="mt-5">
        <vs-tabs position="left" >
            <vs-tab label="Employee Information" icon-pack="feather" icon="icon-user">
                <employee-information/>
                
            </vs-tab>

            <vs-tab label="Accreditation" icon-pack="feather" icon="icon-anchor">
                <employee-accreditation/>
                
            </vs-tab>
            <vs-tab label="Approvers" icon-pack="feather" icon="icon-user-check">
                <employee-approvers/>
                
            </vs-tab>
            <vs-tab label="Association" icon-pack="feather" icon="icon-users">
                <employee-association/>
                
            </vs-tab>

            <vs-tab label="Bank Information" icon-pack="feather" icon="icon-credit-card">
                <employee-bank-information/>
            </vs-tab>

            <vs-tab label="Benefits" icon-pack="feather" icon="icon-box">
               <employee-benefits />
            </vs-tab>

            <vs-tab label="Contacts" icon-pack="feather" icon="icon-phone">
                <employee-contact-references />
            </vs-tab>

            <vs-tab label="Education" icon-pack="feather" icon="icon-award">
               <employee-education />
            </vs-tab>

            <vs-tab label="Family Information" icon-pack="feather" icon="icon-user-check">
                <employee-family-information />
            </vs-tab>

            <vs-tab label="Employee Identification" icon-pack="feather" icon="icon-clipboard">
                <employee-identification/>
               
            </vs-tab>

            <vs-tab label="Job History" icon-pack="feather" icon="icon-book">
               <employee-job-history />
            </vs-tab>

            <vs-tab label="Leave Balance" icon-pack="feather" icon="icon-bold">
                <employee-leave-balance/>
            </vs-tab>

            <vs-tab label="Leave Benefits" icon-pack="feather" icon="icon-zap">
                <employee-leave-benefits/>
            </vs-tab>

            <vs-tab label="Medical Information" icon-pack="feather" icon="icon-thermometer">
                <employee-medical-information />
            </vs-tab>


            <vs-tab label="Performance" icon-pack="feather" icon="icon-percent">
                <employee-performance/>
            </vs-tab>

            <vs-tab label="Previous Employer Data" icon-pack="feather" icon="icon-database">
                <employee-training />
            </vs-tab>
            <vs-tab label="Salary" icon-pack="feather" icon="icon-dollar-sign">
               <employee-salary />
            </vs-tab>
            <vs-tab label="Salary Information" icon-pack="feather" icon="icon-info">
               <employee-salary-information />
            </vs-tab>

            <vs-tab label="Trainings" icon-pack="feather" icon="icon-calendar">
                <employee-training />
            </vs-tab>

            <vs-tab label="Violations" icon-pack="feather" icon="icon-x-circle">
                <employee-violation />
            </vs-tab>
            <vs-tab label="Settings" icon-pack="feather" icon="icon-settings">
                <employee-settings />
            </vs-tab>
            <vs-tab label="201 Files" icon-pack="feather" icon="icon-file-text">
                <file-201 />
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>

import EmployeeInformation from './employee-view/EmployeeInformation'
import EmployeeIdentification from './employee-view/EmployeeIdentification'
import EmployeeAccreditation from './employee-view/EmployeeAccreditation'
import EmployeeApprovers from './employee-view/EmployeeApprovers'
import EmployeeAssociation from './employee-view/EmployeeAssociation'
import EmployeeBankInformation from './employee-view/EmployeeBankInformation'
import EmployeeBenefits from './employee-view/EmployeeBenefits'
import EmployeeContactReferences from './employee-view/EmployeeContactReferences'
import EmployeeEducation from './employee-view/EmployeeEducation'
import EmployeeFamilyInformation from './employee-view/EmployeeFamilyInformation'
import EmployeeJobHistory from './employee-view/EmployeeJobHistory'
import EmployeeLeaveBalance from './employee-view/EmployeeLeaveBalance'
import EmployeeLeaveBenefits from './employee-view/EmployeeLeaveBenefits'
import EmployeeMedicalInformation from './employee-view/EmployeeMedicalInformation'
import EmployeePerformance from './employee-view/EmployeePerformance'
import EmployeeSalary from './employee-view/EmployeeSalary'
import EmployeeSalaryInformation from './employee-view/EmployeeSalaryInformation'
import EmployeeTraining from './employee-view/EmployeeTraining'
import EmployeeViolation from './employee-view/EmployeeViolation'
import EmployeeSettings from './employee-view/EmployeeSettings'
import File201 from './employee-view/File201'

export default {
    components:{
        EmployeeInformation,
        EmployeeIdentification,
        EmployeeAccreditation,
        EmployeeApprovers,
        EmployeeAssociation,
        EmployeeBankInformation,
        EmployeeBenefits,
        EmployeeContactReferences,
        EmployeeEducation,
        EmployeeFamilyInformation,
        EmployeeJobHistory,
        EmployeeLeaveBalance,
        EmployeeLeaveBenefits,
        EmployeeMedicalInformation,
        EmployeePerformance,
        EmployeeSalary,
        EmployeeSalaryInformation,
        EmployeeTraining,
        EmployeeViolation,
        EmployeeSettings,
        File201
    }
}
</script>
        